<div class="card" *ngIf="!loading">
  <div class="card-header">

<h4 class="text-center" [appMath]="title"></h4>


  </div>

  <table  datatable [dtOptions]="dtOptions" class="table table-striped display compact">
    <thead>

          <tr><td>id</td>
            <td>Name</td>
          <td>Syllabus</td></tr>
          </thead>
          <tbody>
          <tr *ngFor="let subTopic of subTopicList;">
              <td>
                <a [routerLink]="['/admin/subtopic/show',subTopic.id]" >
                  {{subTopic.id}}
                </a>
              </td>
              <td>{{subTopic.name}}</td>
              <td>{{subTopic.syllabusCode}}</td>
              </tr>
          </tbody>
         </table>



</div>
<span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>

